import React from "react";

const DoneMarkIcon = ({ color = "black" }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5183_2790)">
        <path
          d="M9.5 0C4.25333 0 0 4.25333 0 9.5C0 14.747 4.25333 19 9.5 19C14.747 19 19 14.747 19 9.5C19 4.25333 14.747 0 9.5 0ZM9.5 17.8312C4.91655 17.8312 1.1875 14.0835 1.1875 9.49996C1.1875 4.91651 4.91655 1.18746 9.5 1.18746C14.0835 1.18746 17.8125 4.91653 17.8125 9.49996C17.8125 14.0834 14.0835 17.8312 9.5 17.8312ZM13.2914 6.02389L7.71754 11.6327L5.20747 9.12267C4.97561 8.89081 4.59976 8.89081 4.36761 9.12267C4.13575 9.35453 4.13575 9.73037 4.36761 9.96223L7.30637 12.9013C7.53823 13.1329 7.91408 13.1329 8.14623 12.9013C8.17295 12.8746 8.19583 12.8455 8.21661 12.8152L14.1315 6.86373C14.3631 6.63187 14.3631 6.25603 14.1315 6.02389C13.8994 5.79203 13.5235 5.79203 13.2914 6.02389Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5183_2790">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DoneMarkIcon;
